import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/salesContent';
import { trackInitiateCheckout } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  note?: string;
  pulse?: boolean;
  /** When set, the button scrolls to this section instead of going to checkout. */
  scrollToId?: string;
};
export function CtaButton({
  children,
  note,
  pulse = true,
  scrollToId
}: CtaButtonProps) {
  const reduceMotion = useReducedMotion();
  const shouldPulse = pulse && !reduceMotion;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!scrollToId) {
      trackInitiateCheckout();
      return;
    }
    const target = document.getElementById(scrollToId);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({
      behavior: reduceMotion ? 'auto' : 'smooth',
      block: 'start'
    });
  };
  return <div className="flex w-full flex-col items-center" data-id="element-22" data-mp="157n6z7w57xqm">
      <motion.a href={scrollToId ? `#${scrollToId}` : CHECKOUT_URL} onClick={handleClick} animate={shouldPulse ? {
      scale: [1, 1.02, 1]
    } : undefined} transition={shouldPulse ? {
      duration: 2.4,
      ease: 'easeInOut',
      repeat: Infinity
    } : undefined} className="group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-full bg-rose px-6 py-4 text-center text-base font-bold uppercase tracking-[0.08em] text-white shadow-lg shadow-rose/30 transition-colors duration-150 ease-out hover:bg-rose-hover focus:outline-none focus-visible:ring-4 focus-visible:ring-rose/30 md:py-5 md:text-lg" data-id="element-23" data-mp="35yh8m1z8z44o">
        <span data-id="element-24" data-mp="1l0wo87xfkit">{children}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-25" data-mp="6ikc3bgd23cc" />
      </motion.a>
      {note && <p className="mt-4 text-center text-sm text-ink-muted" data-id="element-26" data-mp="bfardwkccuwp">{note}</p>}
    </div>;
}